module.exports = __webpack_public_path__ + "static/media/blackberry.85f7caf7.svg";